export default __webpack_public_path__ + "static/media/mesh_macmat_r.3bde8d59.png";